/* ============================================================
   vm150-gallery.js — Velomorph
   Galerie produit en mobile : remplace la rangee Dawn
   "< 1/7 >" par un rang de petits ronds bleus pose en
   surimpression sur le bas de la photo.

   COULEURS
   - Inactifs : bleu eclairci, discrets. Pas le bleu de marque
     #1B3A8C en transparence : sur les visuels fond noir, un
     bleu marine attenue devient invisible. L'eclairci tient sur
     le noir comme sur le clair.
   - Actif : bleu de marque plein, cercle d'un filet blanc fin.
     Le filet est sur l'actif SEULEMENT : sans lui, le marine
     disparait sur une photo noire et l'indicateur ne sert plus
     a rien ; sur tous les ronds, il rendrait le rang criard.

   PIEGE CORRIGE : ne jamais positionner le rang a partir de la
   position COURANTE de la photo active. Cette position bouge en
   continu pendant le glissement, et le rang se decalait avec le
   doigt. La gouttiere et la largeur de photo sont des
   constantes de mise en page : lues via offsetLeft /
   offsetWidth, une seule fois (plus au redimensionnement).

   ATTENTION AUX NOMS DE CLASSE : vm150-dot est deja pris par la
   pastille verte de la date de livraison. Les reperes de
   galerie s'appellent vm150-gdot, regles scopees sous
   .vm150-dots.
   ============================================================ */
(function () {
  'use strict';

  var IDLE = 'rgba(126, 148, 203, 0.78)';
  var ACTIVE_RING = '0 0 0 1.5px rgba(255,255,255,0.85)';

  function injectCSS() {
    if (document.getElementById('vm150-gallery-styles')) return;
    var css = [
      '@media (max-width: 749px) {',
      '  .vm150-gal .slider-buttons { display: none !important; }',
      '  .vm150-gal ul.slider { margin-bottom: 0 !important; }',
      '  .vm150-gal { position: relative; margin-bottom: 0 !important; }',
      '  media-gallery.vm150-has-dots { margin-bottom: 0 !important; display: block; }',
      '  .vm150-dots {',
      '    position: absolute; bottom: 14px;',
      '    display: flex; justify-content: center; align-items: center;',
      '    gap: 9px; margin: 0; padding: 0;',
      '    z-index: 2; pointer-events: none;',
      '  }',
      '  .vm150-dots .vm150-gdot {',
      '    width: 7px; height: 7px; padding: 0; border: 0;',
      '    border-radius: 50%;',
      '    background: ' + IDLE + ';',
      '    box-shadow: none;',
      '    cursor: pointer; pointer-events: auto;',
      '    transition: background-color .2s ease, transform .2s ease, box-shadow .2s ease;',
      '  }',
      '  .vm150-dots .vm150-gdot.is-active {',
      '    background: #1B3A8C;',
      '    box-shadow: ' + ACTIVE_RING + ';',
      '    transform: scale(1.4);',
      '  }',
      '  .vm150-dots .vm150-gdot:focus-visible { outline: 2px solid #fff; outline-offset: 3px; }',
      '}',
      '@media (min-width: 750px) { .vm150-dots { display: none; } }',
      '@media (prefers-reduced-motion: reduce) { .vm150-dots .vm150-gdot { transition: none; } }'
    ].join('\n');
    var s = document.createElement('style');
    s.id = 'vm150-gallery-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function activeIndex(list, slides) {
    var left = list.getBoundingClientRect().left;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var d = Math.abs(slides[i].getBoundingClientRect().left - left);
      if (d < bestDist) { bestDist = d; best = i; }
    }
    return best;
  }

  function setup(gallery) {
    var viewer = gallery.querySelector('slider-component');
    if (!viewer) return;
    var list = viewer.querySelector('ul.slider');
    if (!list) return;
    var slides = Array.prototype.slice.call(list.querySelectorAll('li.slider__slide'));
    if (slides.length < 2) return;
    if (viewer.querySelector('.vm150-dots')) return;

    viewer.classList.add('vm150-gal');
    gallery.classList.add('vm150-has-dots');

    var row = document.createElement('div');
    row.className = 'vm150-dots';
    row.setAttribute('aria-label', 'Imágenes del producto');

    var dots = slides.map(function (slide, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vm150-gdot';
      b.setAttribute('aria-label', 'Imagen ' + (i + 1) + ' de ' + slides.length);
      b.addEventListener('click', function () {
        var delta = slides[i].getBoundingClientRect().left - list.getBoundingClientRect().left;
        if (list.scrollBy) {
          list.scrollBy({ left: delta, behavior: 'smooth' });
        } else {
          list.scrollLeft += delta;
        }
      });
      row.appendChild(b);
      return b;
    });

    viewer.appendChild(row);

    // Gabarit fixe, independant du defilement.
    function place() {
      var gutter = slides[0].offsetLeft;
      var width = slides[0].offsetWidth;
      var listLeft = list.offsetLeft;
      if (!width) return;
      row.style.left = (listLeft + gutter) + 'px';
      row.style.width = width + 'px';
    }

    function paint() {
      var active = activeIndex(list, slides);
      for (var i = 0; i < dots.length; i++) {
        var on = i === active;
        dots[i].classList.toggle('is-active', on);
        dots[i].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      // setTimeout plutot que requestAnimationFrame : rAF ne se
      // declenche pas dans un onglet en arriere-plan.
      setTimeout(function () { ticking = false; paint(); }, 60);
    }

    list.addEventListener('scroll', schedule, { passive: true });

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(schedule, {
        root: list,
        threshold: [0.25, 0.6, 0.9]
      });
      slides.forEach(function (s) { io.observe(s); });
    }

    viewer.addEventListener('slideChanged', paint);
    window.addEventListener('resize', function () { place(); schedule(); });

    place();
    paint();
  }

  function init() {
    injectCSS();
    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) setup(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // La galerie est re-rendue par Dawn au changement de variante.
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; init(); }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
